/* eslint-disable react/no-array-index-key */
import React from 'react';
import { suspectsType } from '../proptypes/deception';
import { Tick, Cross, Slash } from './UiIcons';

const renderIcon = (correct) => {
  if (correct === true) return <Tick />;
  if (correct === false) return <Cross />;

  return <Slash />;
};

const DeceptionSuspectList = ({ suspects }) => (
  <div className="deception-suspect-list">
    {
      suspects.map(({ imgSrc, correct }, index) => (
        <div
          key={`suspect-${imgSrc}`}
          className={`suspect suspect-${index}`}
          style={{
            backgroundImage: `url("${imgSrc}")`,
          }}
        >
          <div className="aspect-ratio-box">
            <div className="aspect-content-container">
              <div className="suspect-label">
                {String.fromCharCode(65 + index)}
              </div>
              { renderIcon(correct) }
            </div>
          </div>
        </div>
      ))
    }
  </div>
);

DeceptionSuspectList.propTypes = {
  suspects: suspectsType.isRequired,
};

export default DeceptionSuspectList;
